import { render, staticRenderFns } from "./ListRequestTypes.vue?vue&type=template&id=afc1918a&"
import script from "./ListRequestTypes.vue?vue&type=script&lang=js&"
export * from "./ListRequestTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports